import CardRating from './CardRating';

export default CardRating;
